import React, { Component, Fragment } from 'react';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import PropertyIcon from '@material-ui/icons/DomainTwoTone';
import TimeIcon from '@material-ui/icons/AccessTimeTwoTone';
import AgentIcon from '@material-ui/icons/PersonTwoTone';
import CancelIcon from '@material-ui/icons/CancelTwoTone';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { AccentColor } from 'helpers/AccentColorHelper';

import FooterButtons from 'components/shared/FooterButtons';
import { ShowingStatus } from 'components/shared/StatusHelper';
import TenantDetails from 'components/landlord_app/tenants/components/TenantDetails.js';

import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import { CSSTransitionGroup } from 'react-transition-group';

import Header from 'components/shared/Header';
import ShowingsNonGrid from './ShowingsNonGrid';
import EditLeadBasicDialog from 'components/landlord_app/tenants/components/EditLeadBasicDialog';

import EventTimeline from 'components/shared/EventTimeline';

import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const pageViewHeaders = {
  DETAILS: { name: 'details', formName: '' },
  MODIFY_ASSIGN: { name: 'modify_assign', formName: '' },
  EVENTS: { name: 'events', formName: '' },
};

const SignupSchema = Yup.object().shape({
  cancelShowingReason: Yup.string()
    .min(16, 'Cancellation reason must be at least 16 characters.')
    .max(100, 'Cancellation reason must be less than 100 characters.')
    .required('Enter reason for cancelling the showing.'),
});
const theme = createMuiTheme({
  typography: {
    fontFamily: '"Circular", sans-serif',
    useNextVariants: true,
  },
});
const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '15px',
  },
};

const Tab = ({ children, isActive, ...rest }) => (
  <div className={`col-xs-4`} style={{ height: '100%' }}>
    <div style={{ textAlign: 'center' }}>
      <button
        type="button"
        className="link-button"
        onClick={() => this.pageView(pageViewHeaders.DETAILS)}
        {...rest}
        style={{
          color: AccentColor(),
          fontFamily: 'Circular-Bold',
        }}
      >
        {children}
      </button>
    </div>
    <div
      style={{
        width: '100%',
        height: '2px',
        position: 'absolute',
        bottom: 0,
        left: 0,
        backgroundColor: AccentColor(),
        display: isActive ? 'block' : 'none',
      }}
    />
  </div>
);

export default class ShowingOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openView: pageViewHeaders.DETAILS.name,
      formName: pageViewHeaders.DETAILS.formName,
      leadDialogOpen: false,
      confirmationDialogOpen: false,
      errorTextField: false,
    };
  }

  pageView = (pageToView) => {
    this.setState({
      openView: pageToView.name,
      formName: pageToView.formName,
    });
  };

  toggleEditTenantDialog = () => {
    this.setState((prevState) => ({
      leadDialogOpen: !prevState.leadDialogOpen,
    }));
  };

  toggleDialog = () => {
    this.setState({
      confirmationDialogOpen: !this.state.confirmationDialogOpen,
    });
  };

  deleteShowing = (cancelShowingReason) => {
    this.props.cancelShowing(cancelShowingReason);
    this.toggleDialog();
  };

  render() {
    const { toggleDrawer } = this.props;

    return (
      <Fragment>
        <EditLeadBasicDialog
          isOpen={this.state.leadDialogOpen}
          toggleDialog={this.toggleEditTenantDialog}
          leadDetails={this.props.showingDetails.lead_details}
          callback={this.props.getShowingAndShowings}
        />

        <div
          className="row"
          style={{ width: '100%', minHeight: '65px', padding: '10px', backgroundColor: 'white' }}
        >
          <h2 style={{ textAlign: 'center', margin: '8px 0' }}>
            {this.props.showingDetails.lead_details.full_name} &nbsp;
            <span>
              {
                <ShowingStatus
                  style={{ fontSize: '41%', display: 'inline-table' }}
                  status={this.props.showingDetails.status}
                />
              }
            </span>
          </h2>
        </div>
        <div
          className="row"
          style={{ width: '100%', height: '29px', padding: '0 10px', backgroundColor: 'white' }}
        >
          <Tab
            onClick={() => this.pageView(pageViewHeaders.DETAILS)}
            isActive={this.state.openView === pageViewHeaders.DETAILS.name}
          >
            Overview
          </Tab>
          <Tab
            onClick={() => this.pageView(pageViewHeaders.MODIFY_ASSIGN)}
            isActive={this.state.openView === pageViewHeaders.MODIFY_ASSIGN.name}
          >
            Modify/Assign
          </Tab>
          <Tab
            onClick={() => {
              this.props.getHistory(this.props.showingDetails.id);
              this.pageView(pageViewHeaders.EVENTS);
            }}
            isActive={this.state.openView === pageViewHeaders.EVENTS.name}
          >
            History
          </Tab>
        </div>
        <div
          style={{
            padding: '15px',
            height: 'calc(100% - 155px)',
            overflow: 'scroll',
            backgroundColor: '#fbfbfb',
          }}
        >
          <CSSTransitionGroup
            transitionName="fade_out_buttons"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {this.state.openView === pageViewHeaders.DETAILS.name && (
              <div className="row">
                {/************ Showing Details **************/}
                <h3 style={{ margin: '0 0 15px' }}> Showing Details </h3>
                <Card style={style.transactionCard}>
                  <CardText style={{ padding: '0' }}>
                    <Header name="DETAILS" />
                    <div className="row" style={{ padding: '15px 15px 25px' }}>
                      {this._renderShowingDetails()}
                      <div className="row" style={{ marginTop: '15px' }}>
                        {this._renderNoShowBooking()}
                        {this._renderCancelBooking()}
                      </div>
                    </div>
                  </CardText>
                </Card>
                <div className="row" style={{ marginTop: '25px' }}>
                  <TenantDetails
                    tenantDetails={this.props.showingDetails.lead_details}
                    leadID={this.props.showingDetails.lead_details.lead_id}
                    toggleEditTenantDialog={this.toggleEditTenantDialog}
                    hideInvite
                    isProspect
                    editButtonLabelText={'Edit Lead'}
                    showLeaseSection={false}
                  />
                </div>
              </div>
            )}

            {this.state.openView === pageViewHeaders.MODIFY_ASSIGN.name && (
              <div className="row">
                <h3 style={{ margin: '0 0 15px' }}> Modify/Assign </h3>
                {/************ MOdify/Assign **************/}
                {this._renderCompleteNoModify()}
                <Card style={style.transactionCard}>
                  <CardText style={{ padding: '0' }}>
                    {this._renderModifyShowing()}
                    {this._renderReAssignToAgent()}
                    {this._renderAssignToAgent()}
                  </CardText>
                </Card>
              </div>
            )}

            {this.state.openView === pageViewHeaders.EVENTS.name && (
              <div className="row">
                <h3 style={{ margin: '0 0 15px' }}> History </h3>
                {/************ History **************/}
                <Card style={style.transaction_card}>
                  <CardText style={{ padding: '0 10px' }}>
                    <EventTimeline events={this.props.bookingHistory} />
                  </CardText>
                </Card>
              </div>
            )}
          </CSSTransitionGroup>
        </div>
        <div
          style={{
            flex: '0 0 auto',
            margin: '8px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <FooterButtons
            backName="Close"
            formName={this.state.formName}
            hideSubmitButton
            backAction={toggleDrawer}
          />
        </div>
      </Fragment>
    );
  }

  _renderShowingDetails = () => (
    <div className="row" style={{ marginTop: '5px' }}>
      <h5 style={{ fontSize: '17px' }}>
        <span>
          <PropertyIcon size={16} style={{ verticalAlign: 'text-bottom', color: AccentColor() }} />
        </span>
        &nbsp;
        {this.props.showingDetails.property_details.name}
      </h5>
      <h5 style={{ fontSize: '17px' }}>
        <span>
          <AgentIcon size={16} style={{ verticalAlign: 'text-bottom', color: AccentColor() }} />
        </span>
        &nbsp;
        {this.props.showingDetails.status === 'complete'
          ? `Completed by ${this.props.showingDetails.assigned_agent}`
          : `Assigned to ${this.props.showingDetails.assigned_agent}`}
      </h5>
      <h5 style={{ fontSize: '17px' }}>
        <span>
          <TimeIcon size={16} style={{ verticalAlign: 'text-bottom', color: AccentColor() }} />
        </span>
        &nbsp;{this.props.showingDetails.date} at {this.props.showingDetails.time}
      </h5>
      {this.props.showingDetails.cancelled && this.props.showingDetails.cancellation_reason ? (
        <div style={{ display: 'flex' }}>
          <div>
            <CancelIcon
              size={16}
              style={{
                color: AccentColor(),
                marginRight: 4,
              }}
            />
          </div>
          <div>
            <h5 style={{ fontSize: '17px', marginTop: 0, lineHeight: 1.5 }}>
              Reason for cancellation: {this.props.showingDetails.cancellation_reason}
            </h5>
          </div>
        </div>
      ) : null}
    </div>
  );

  _renderCancelBooking = () => {
    if (['no_show', 'complete', 'cancelled', 'assign'].includes(this.props.showingDetails.status))
      return;

    return (
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <FlatButton onClick={this.toggleDialog} style={{ color: AccentColor(), padding: '0 15px' }}>
          CANCEL BOOKING
        </FlatButton>
        <MuiThemeProvider theme={theme}>
          <Dialog disableBackdropClick open={this.state.confirmationDialogOpen} fullWidth>
            <DialogTitle>Cancel Showing</DialogTitle>
            <DialogContent>
              <DialogContentText>Enter a reason for cancelling this showing</DialogContentText>
              <Formik
                initialValues={{
                  cancelShowingReason: '',
                }}
                validationSchema={SignupSchema}
                onSubmit={(values) => {
                  this.deleteShowing(values.cancelShowingReason);
                }}
              >
                {({ values, errors, touched, handleChange }) => (
                  <Form>
                    <TextField
                      name="cancelShowingReason"
                      autoFocus
                      margin="dense"
                      id="cancellation_reason"
                      label="Reason for cancellation"
                      type="text"
                      fullWidth
                      multiLine
                      variant="outline"
                      value={values.cancelShowingReason}
                      onChange={handleChange}
                    />
                    {errors.cancelShowingReason && touched.cancelShowingReason ? (
                      <div style={{ color: '#ff3333' }}>{errors.cancelShowingReason}</div>
                    ) : null}

                    <DialogActions style={{ justifyContent: 'space-between' }}>
                      <FlatButton label="Close" primary={true} onClick={this.toggleDialog} />
                      <FlatButton label="Cancel Showing" primary={true} type="submit" />
                    </DialogActions>
                  </Form>
                )}
              </Formik>
            </DialogContent>
          </Dialog>
        </MuiThemeProvider>
      </div>
    );
  };

  _renderNoShowBooking = () => {
    if (['no_show', 'complete', 'cancelled'].includes(this.props.showingDetails.status)) return;

    return (
      <div className="col-sm-6" style={{ textAlign: 'center' }}>
        <FlatButton
          label="mark no show"
          primary={true}
          keyboardFocused={false}
          onClick={this.props.markNoShow}
          style={{
            backgroundColor: AccentColor(),
            padding: '0 15px',
            color: 'white',
            marginBottom: '10px',
          }}
        />
      </div>
    );
  };

  _renderAssignToAgent = () => {
    if (!['upcoming', 'assign', null].includes(this.props.showingDetails.status)) return;

    return (
      <Fragment>
        <Header name="COMPLETE SHOWING" />
        <ShowingsNonGrid showAssign getShowingAndShowings={this.props.getShowingAndShowings} />
      </Fragment>
    );
  };

  _renderReAssignToAgent = () => {
    if (['assign', 'complete', 'no_show'].includes(this.props.showingDetails.status)) return;

    return (
      <Fragment>
        <Header name="CHANGE SHOWING AGENT" />
        <ShowingsNonGrid showReAssign getShowingAndShowings={this.props.getShowingAndShowings} />
      </Fragment>
    );
  };

  _renderCompleteNoModify = () => {
    if (!['no_show', 'complete'].includes(this.props.showingDetails.status)) return;
    const noShowOrComplete =
      this.props.showingDetails.status === 'complete' ? 'complete' : 'no show';

    return <p>A showing cannot be modified once it is marked as {noShowOrComplete}.</p>;
  };

  _renderModifyShowing = () => {
    if (['no_show', 'complete'].includes(this.props.showingDetails.status)) return;

    return (
      <Fragment>
        <Header name="MODIFY SHOWING" />
        <ShowingsNonGrid showModify getShowingAndShowings={this.props.getShowingAndShowings} />
      </Fragment>
    );
  };
}
